import { render, staticRenderFns } from "./filexchange.vue?vue&type=template&id=0bca68d4&scoped=true&"
import script from "./filexchange.vue?vue&type=script&lang=js&"
export * from "./filexchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca68d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bca68d4')) {
      api.createRecord('0bca68d4', component.options)
    } else {
      api.reload('0bca68d4', component.options)
    }
    module.hot.accept("./filexchange.vue?vue&type=template&id=0bca68d4&scoped=true&", function () {
      api.rerender('0bca68d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/user/profile/tabs/filexchange.vue"
export default component.exports